module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABAElEQVQ4T63UMS8EQRjG8f873X0a2ZVINK6lETQqFWd70V5DL1qzJ5EoJUQUdBKNyiY+hM+gMs9luU3uOLt27NQzv3nzzDuvLea6CGLHwBGxBMEZl5Z4fZh4xTjG8d7KCvQQQxkLlnoJ2Cr27aYVMtmcem0C15+QHLsGTzGQYMUC51VFMcbMmf9XJPomRl8VOdaKPXuIKSsdaZXAfWsoyVXmmRUDWyovjoJKBHHqxPpLZo+10PKJes8H9qOf5iG1UJrrjcBRkdlZldlvSC2UePUN7jAOi4H5OqQxoynsVmJjOpPvL9sY9gS7MrFdBTuvPRqhv/bULNTFp+1sjHQ12MadLdKHnL+6agAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/dzy/assets/img/ApprovedD.png
// module id = vhSy
// module chunks = 43